import { makeStyles } from '@material-ui/core/styles';

export const useStyles = makeStyles(theme => ({
  root: {
    height: 60,
    width: 60,
    borderRadius: 20,
    backgroundColor: theme.palette.grey[200],
  },
}));
